import Helpers from "@helpers"
import * as React from "react"
import overlayHelper from "../overlay/overlay"
import { AddressModalHelper, State } from "./model"
import ShippingListHelper from "../shipping-list/shipping_list"
import LeafletMap from "../map/leaflet"
import log from "video.js/dist/types/utils/log"

const emptyOption = (
  <option key="-1" value="-1">
    -
  </option>
)
const tehranCityId = 211
const AddressModalHelper: AddressModalHelper = {}

class AddressModal extends React.Component<{}, State> {
  private onFinished
  constructor(props) {
    super(props)

    this.state = this.getInitialState()
  }

  public componentDidMount() {
    AddressModalHelper.openAddressModal = this.openModal
  }

  public render() {
    return (
      <div
        className="modal address-modal"
        style={{ display: this.getModalDisplayStyle() }}
      >
        <div className="fa fa-remove close-windows" onClick={this.closeModal} />

        <div className="row rounded address-form text-fa-h4 rtl">
          <div className="w-100 text-center mb-3">
            <h3>افزودن آدرس جدید</h3>
            <span>جزئیات آدرس را تکمیل نمایید</span>
          </div>

          <div className="row custom-gutter modal-form-row">
            <div className="col-lg-4 half-width">
              <label>استان</label>
              <div>
                <select
                  className="form-control"
                  onChange={this.onProvinceChanged}
                  value={this.state.provinceId}
                >
                  {this.getProvinces()}
                </select>
              </div>
            </div>
            <div className="col-lg-4 half-width">
              <label>شهر</label>
              <div>
                <select
                  className="form-control"
                  onChange={this.onCityChanged}
                  value={this.state.cityId}
                >
                  {this.getCities()}
                </select>
              </div>
              <div
                className="address-validation"
                style={{
                  display: this.getErrorDisplayStyle(
                    this.state.cityErrorMessage
                  ),
                }}
              >
                {this.state.cityErrorMessage}
              </div>
            </div>
            <div className="col-lg-4 half-width">
              <label>کد پستی</label>
              <div>
                <input
                  type="text"
                  className="form-control address-postal-code"
                  onChange={this.onPostalCodeChanged}
                  value={this.state.postalCode}
                />
                <div
                  className="address-validation"
                  style={{
                    display: this.getErrorDisplayStyle(
                      this.state.postalCodeErrorMessage
                    ),
                  }}
                >
                  {this.state.postalCodeErrorMessage}
                </div>
              </div>
            </div>
          </div>

          <div
            className="row custom-gutter modal-form-row"
            style={{ display: this.getSuburbDisplay() }}
          >
            <div className="col-lg-4 half-width">
              <label>محدوده</label>
              <div>
                <select
                  className="form-control"
                  onChange={this.onRegionChanged}
                  value={this.state.region}
                >
                  {this.getRegions()}
                </select>
              </div>
            </div>

            <div className="col-lg-4 half-width pr-1">
              <label>محله</label>
              <div>
                <select
                  className="form-control"
                  onChange={this.onSuburbChanged}
                  value={this.state.suburbId}
                >
                  {this.getSuburbs()}
                </select>
                <div
                  className="address-validation"
                  style={{
                    display: this.getErrorDisplayStyle(
                      this.state.suburbErrorMessage
                    ),
                  }}
                >
                  {this.state.suburbErrorMessage}
                </div>
              </div>
            </div>
          </div>

          <div className="row custom-gutter modal-form-row flex-column modal-address-input">
            <label>آدرس</label>
            <div>
              <textarea
                rows={3}
                className="address-input"
                onChange={this.onAddressChanged}
                value={this.state.address}
              />
            </div>
            <div
              className="address-validation"
              style={{
                display: this.getErrorDisplayStyle(
                  this.state.addressErrorMessage
                ),
              }}
            >
              {this.state.addressErrorMessage}
            </div>
          </div>

          <div className="row custom-gutter modal-form-row">
            <div className="col-lg-4 half-width">
              <label>پلاک</label>
              <div>
                <input
                  type="text"
                  className="form-control address-number"
                  onChange={this.onAddressNumberChanged}
                  value={this.state.addressNumber}
                />
                <div
                  className="address-validation"
                  style={{
                    display: this.getErrorDisplayStyle(
                      this.state.addressNumberErrorMessage
                    ),
                  }}
                >
                  {this.state.addressNumberErrorMessage}
                </div>
              </div>
            </div>
            <div className="col-lg-4 half-width">
              <label>واحد</label>
              <div>
                <input
                  type="text"
                  className="form-control address-number2"
                  onChange={this.onAddressNumber2Changed}
                  value={this.state.addressNumber2}
                />
                <div
                  className="address-validation"
                  style={{
                    display: this.getErrorDisplayStyle(
                      this.state.addressNumber2ErrorMessage
                    ),
                  }}
                >
                  {this.state.addressNumber2ErrorMessage}
                </div>
              </div>
            </div>
          </div>

          <div>
            <div
              className="address-modal-error"
              style={{
                display: this.getErrorDisplayStyle(this.state.errorMessage),
              }}
            >
              {this.state.errorMessage}
            </div>
          </div>

          <button
            className="btn btn-red address-modal-save profile-button-container "
            onClick={this.onSubmit}
          >
            ذخیره
          </button>
        </div>
      </div>
    )
  }

  private getInitialState = (): State => ({
    visible: false,
    cities: null,
    provinces: null,
    regions: null,
    suburbs: null,
    provinceId: -1,
    cityId: -1,
    region: "",
    suburbId: -1,
    postalCode: "",
    address: "",
    addressId: 0,
    cityErrorMessage: "",
    addressErrorMessage: "",
    postalCodeErrorMessage: "",
    suburbErrorMessage: "",
    errorMessage: "",
    uid: 0,
    hps: "",
    forceExUser: 0,
    latitude: null,
    longitude: null,
  })

  private openModal = (addressId, address, lat, lng, onFinished) => {
    this.onFinished = onFinished
    overlayHelper.onClick = this.closeModal
      overlayHelper.showOverlay()

      this.setState({
          visible: true,
          latitude: lat,
          longitude: lng,
          address: address
      })

      if (addressId) {
         
      Helpers.LoadingHelper.showLoading()

      var forceExUser = 0
      var uid = 0
      var hps = ""

      if ($("#hdfForceExUser").length > 0) {
        forceExUser = Helpers.Utils.zeroIfEmpty(
          $("#hdfForceExUser").val().toString()
        )
      }
      if ($("#hdfUId").length > 0) {
        uid = Helpers.Utils.zeroIfEmpty($("#hdfUId").val().toString())
      }
      if ($("#hdfHps").length > 0) {
        hps = $("#hdfHps").val().toString()
      }
      const getAddressPromise = Helpers.ApiHelper.getAddress(
        addressId,
        forceExUser,
        uid,
        hps
          )

      const getProvincesPromise = Helpers.ApiHelper.getProvinces()

      Promise.all([getAddressPromise, getProvincesPromise])
        .then((addressPromiseResponse) => {
          const [address, provinces] = addressPromiseResponse
          if (!address) return
            
            const state: State = {
                visible: true,
                provinces,
                /*address: address.address,*/
                postalCode: address.postalCode,
                provinceId: address.provinceId,
                cityId: address.cityId,
                region: address.region || "",
                suburbId: address.suburbId || -1,
                addressId,
            }

            if (window.location.pathname == '/Admin/ProductFactorNew.aspx')
            {
                state.address = address.address;
            }

          const getCitiesPromise = Helpers.ApiHelper.getCities(
            address.provinceId
          )
          const promises = [getCitiesPromise]

          if (address.suburbId) {
            const getRegionsPromise = Helpers.ApiHelper.getRegions(
              address.cityId
            )
            const getSuburbsPromise = Helpers.ApiHelper.getSuburbs(
              address.cityId,
              address.region
            )
            promises.push(getRegionsPromise)
            promises.push(getSuburbsPromise)
          }

          Helpers.LoadingHelper.showLoading()

          Promise.all(promises)
            .then((cityRegionSuburbResponse) => {
              const [cities, regions, suburbs] = cityRegionSuburbResponse

              state.cities = cities
              state.regions = regions
              state.suburbs = suburbs

              this.setState(state)
            })
            .finally(() => {
              Helpers.LoadingHelper.hideLoading()
            })
        })
        .finally(() => {
          Helpers.LoadingHelper.hideLoading()
        })
    } else {
      this.setState({
        address,
        latitude: lat,
        longitude: lng,
      })
      Helpers.LoadingHelper.showLoading()
      Helpers.ApiHelper.getProvinces()
        .then((provinces) => {
          this.setState({
            visible: true,
            provinces,
          })
        })
        .always((_) => {
          Helpers.LoadingHelper.hideLoading()
        })
    }
  }

  private clearModal = () => {
    this.setState(this.getInitialState())
  }

  private onProvinceChanged = (event) => {
    const provinceId = Helpers.Utils.zeroIfEmpty(event.target.value)

    const resetState: State = {
      cities: null,
      regions: null,
      suburbs: null,
      cityId: -1,
      suburbId: -1,
    }

    if (provinceId === -1) {
      this.setState({
        ...resetState,
      })

      return
    }

    Helpers.LoadingHelper.showLoading()
    Helpers.ApiHelper.getCities(provinceId)
      .then((cities) => {
        this.setState({
          ...resetState,
          provinceId,
          cities,
        })
      })
      .always((_) => {
        Helpers.LoadingHelper.hideLoading()
      })
  }

  private onCityChanged = (event) => {
    const cityId = Helpers.Utils.zeroIfEmpty(event.target.value)

    const resetState: State = {
      regions: null,
      suburbs: null,
      suburbId: -1,
      cityErrorMessage: null,
    }

    if (cityId === tehranCityId) {
      Helpers.LoadingHelper.showLoading()
      Helpers.ApiHelper.getRegions(cityId)
        .then((regions) => {
          this.setState({
            ...resetState,
            cityId,
            regions,
          })
        })
        .always((_) => {
          Helpers.LoadingHelper.hideLoading()
        })
    } else {
      this.setState({
        ...resetState,
        cityId,
      })
    }
  }

  private onRegionChanged = (event) => {
    const regionId: string = event.target.value

    const resetState: State = {
      suburbs: null,
      suburbId: -1,
    }

    Helpers.LoadingHelper.showLoading()
    Helpers.ApiHelper.getSuburbs(this.state.cityId, regionId)
      .then((suburbs) => {
        this.setState({
          ...resetState,
          region: regionId,
          suburbs,
        })
      })
      .always((_) => {
        Helpers.LoadingHelper.hideLoading()
      })
  }

  private onSuburbChanged = (event) => {
    const suburbId = Helpers.Utils.zeroIfEmpty(event.target.value)
    this.setState({
      suburbId,
      suburbErrorMessage: null,
    })
  }

  private onLatitudeChanged = (event) => {
    var latitude = event.target.value
    this.setState({
      latitude,
    })
  }
  private onLongitudeChanged = (event) => {
    var longitude = event.target.value
    this.setState({
      longitude,
    })
  }

  private getProvinces = () => {
    let provinces = [emptyOption]
    if (this.state.provinces) {
      const items = this.state.provinces.map((province) => (
        <option key={province.id} value={province.id}>
          {province.title}
        </option>
      ))
      provinces = provinces.concat(items)
    }

    return provinces
  }

  private getCities = () => {
    let cities = [emptyOption]
    if (this.state.cities) {
      const items = this.state.cities.map((city) => (
        <option key={city.id} value={city.id}>
          {city.title}
        </option>
      ))

      cities = cities.concat(items)
    }

    return cities
  }

  private getRegions = () => {
    let regions = [emptyOption]
    if (this.state.regions) {
      const items = this.state.regions.map((region) => (
        <option key={region} value={region}>
          {region}
        </option>
      ))

      regions = regions.concat(items)
    }

    return regions
  }

  private getSuburbs = () => {
    let suburbs = [emptyOption]
    if (this.state.suburbs) {
      const items = this.state.suburbs.map((suburb) => (
        <option key={suburb.id} value={suburb.id}>
          {suburb.title}
        </option>
      ))

      suburbs = suburbs.concat(items)
    }

    return suburbs
  }

  private getSuburbDisplay = () =>
    this.state.cityId === tehranCityId ? "flex" : "none"

  private getModalDisplayStyle = () => (this.state.visible ? "block" : "none")

  private onPostalCodeChanged = (event) => {
    this.setState({
      postalCode: event.target.value,
      postalCodeErrorMessage: null,
    })
  }
  private onAddressNumberChanged = (event) => {
    this.setState({
      addressNumber: event.target.value,
      addressNumberErrorMessage: null,
    })
  }
  private onAddressNumber2Changed = (event) => {
    this.setState({
      addressNumber2: event.target.value,
    })
  }
  private onAddressChanged = (event) => {
    this.setState({
      address: event.target.value,
      addressErrorMessage: null,
    })
  }

  private getErrorDisplayStyle = (errorMessage) =>
    errorMessage && errorMessage.length > 0 ? "block" : "none"

  private validateForm = () => {
    const cityErrorMessage =
      this.state.cityId && this.state.cityId > 0
        ? ""
        : "لطفا شهر را انتخاب نمائید."

    const addressErrorMessage =
      this.state.address && this.state.address.length > 10
        ? ""
        : "لطفا آدرس را بدرستی وارد نمائید."

    const postalCodeRegex = new RegExp(/^\d{10}$/g)
    const postalCodeErrorMessage =
      this.state.postalCode && postalCodeRegex.test(this.state.postalCode)
        ? ""
        : "لطفا کد پستی را بدرستی وارد نمائید."

    const suburbErrorMessage =
      this.state.suburbId &&
      this.state.cityId &&
      this.state.cityId === tehranCityId &&
      this.state.suburbId <= 0
        ? "لطفا محله را انتخاب نمائید."
              : ""

    const addressNumberRegex = new RegExp(/^\d{1,10}$/g)
    const addressNumberErrorMessage =
      this.state.addressNumber && this.state.addressNumber.length > 0 && addressNumberRegex.test(this.state.addressNumber)
        ? ""
        : "وارد کردن پلاک به صورت عددی الزامی است"

    const addressNumber2Regex = new RegExp(/^\d{1,10}$/g)
    const addressNumber2ErrorMessage =
      !this.state.addressNumber2 || addressNumber2Regex.test(this.state.addressNumber2)
        ? ""
        : "شماره واحد باید به صورت عددی وارد شود"

    const hasError =
      cityErrorMessage.length > 0 ||
      addressErrorMessage.length > 0 ||
      postalCodeErrorMessage.length > 0 ||
      suburbErrorMessage.length > 0 ||
      addressNumberErrorMessage.length > 0 ||
      addressNumber2ErrorMessage.length > 0

    return {
      cityErrorMessage,
      addressErrorMessage,
      postalCodeErrorMessage,
      suburbErrorMessage,
      addressNumberErrorMessage,
      addressNumber2ErrorMessage,
      hasError,
    }
  }

  private onSubmit = (e) => {
    const errors = this.validateForm()

    if (errors.hasError) {
      const cityErrorMessage = errors.cityErrorMessage
      const addressErrorMessage = errors.addressErrorMessage
      const postalCodeErrorMessage = errors.postalCodeErrorMessage
      const suburbErrorMessage = errors.suburbErrorMessage
      const addressNumberErrorMessage = errors.addressNumberErrorMessage
      const addressNumber2ErrorMessage = errors.addressNumber2ErrorMessage

      this.setState({
        ...this.state,
        cityErrorMessage,
        addressErrorMessage,
        postalCodeErrorMessage,
        suburbErrorMessage,
        addressNumberErrorMessage,
        addressNumber2ErrorMessage
      })

      e.preventDefault()
      return false
      }

    var forceExUser = 0
    var uid = 0
    var hps = ""

    if ($("#hdfForceExUser").length > 0) {
      forceExUser = Helpers.Utils.zeroIfEmpty(
        $("#hdfForceExUser").val().toString()
      )
    }
    if ($("#hdfUId").length > 0) {
      uid = Helpers.Utils.zeroIfEmpty($("#hdfUId").val().toString())
    }
    if ($("#hdfHps").length > 0) {
      hps = $("#hdfHps").val().toString()
    }

    Helpers.LoadingHelper.showLoading()
    Helpers.ApiHelper.addOrUpdateAddressAsync(
      this.state.addressId,
      this.state.cityId,
      this.state.suburbId,
        this.state.postalCode,
        this.state.address + '، پلاک ' + this.state.addressNumber + (this.state.addressNumber2 ? '، واحد ' + this.state.addressNumber2 :''),
      this.state.latitude,
      this.state.longitude,
      forceExUser,
      uid,
      hps
    )
      .then((_) => {
        this.closeModal()
        this.onFinished()
        ShippingListHelper.reloadList(
          Helpers.Utils.zeroIfEmpty($("#hfdAddressId").val().toString())
        )
      })
      .fail((err) => {
        this.setState({
          ...this.state,
          errorMessage: "خطایی رخ داده است، لطفا مجددا سعی نمائید.",
        })
      })
      .always((_) => {
        Helpers.LoadingHelper.hideLoading()
      })

    
    e.preventDefault()
    return false
  }

  private closeModal = () => {
    this.setState({
      visible: false,
    })

    overlayHelper.hideOverlay()
    this.clearModal()
  }
}

Helpers.ReactHelper.createReactElement("AddressModal", AddressModal)

export default AddressModalHelper
